import { makeRequest } from 'utils/requestLogger';

const joinFirstOrtInCourse = (course_id, user_id) =>
  makeRequest(
    'put',
    `api/courses/${course_id}/participants/${user_id}/has_joined_first_roundtable`
  );

export default joinFirstOrtInCourse;



// WEBPACK FOOTER //
// ./src/app/services/courses/joinFirstOrtInCourse.js